import React from 'react';
import { List, Typography, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import { Downgraded, useState } from '@hookstate/core';

const listStyle = {
    width: '100%',
    height: '200px',
    // border: 1,
    // borderColor: 'primary.main',
    border: '1px solid #969696',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '5px',
        height: '5px',
        backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
    },
};
const ListContainer = (props) => {
    const selected = useState([]);
    const handleToggle = (value) => {
        const newSelected = selected.attach(Downgraded).get();
        const currentIndex = newSelected.indexOf(value.moduleID);
        if (currentIndex === -1) {
            newSelected.push(value.moduleID);
        } else {
            newSelected.splice(currentIndex, 1);
        }
        selected.set(newSelected);
        props.setSelectModule(selected.get());
    };

    return (
        <>
            {props.loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                    }}>
                    <CircularProgress />
                </Box>
            ) : (
                <List sx={listStyle}>
                    {props.data && props.data.length > 0 ? (
                        props.data.map((item, index) => {
                            const labelId = `checkbox-list-label-${index}`;
                            return (
                                <ListItem key={`user_${index}`} disablePadding>
                                    <ListItemButton
                                        role={undefined}
                                        onClick={() => handleToggle(item)}
                                        dense>
                                        <ListItemIcon sx={{ height: '28px' }}>
                                            <Checkbox
                                                edge="start"
                                                checked={
                                                    selected
                                                        .get()
                                                        .indexOf(
                                                            item.moduleID
                                                        ) !== -1
                                                }
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{
                                                    'aria-labelledby': labelId,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '100%',
                                                width: '100%',
                                            }}>
                                            <ListItemText sx={{ display: 'flex', justifyContent: 'flex-start', width: '50%' }}
                                                id={labelId}
                                                primary={
                                                    item.moduleName ===
                                                        'DraftHotel'
                                                        ? 'PlayerHotel'
                                                        : item.moduleName
                                                }
                                            />
                                            {/* <Typography
                                                fontSize={11}
                                                sx={{
                                                    wordBreak: 'break-word',
                                                    display:'flex', justifyContent: 'flex-start'
                                                }}>
                                                <a>                                                   
                                                    {item.description}
                                                </a>
                                            </Typography> */}
                                            <ListItemText
                                                sx={{ display: 'flex', justifyContent: 'flex-start', width: '50%' }}
                                                id={labelId}
                                            ><Typography
                                                fontSize={11}
                                                sx={{
                                                    wordBreak: 'break-word',
                                                    color: 'blue'
                                                }}>

                                                    {item.description}

                                                </Typography></ListItemText>
                                        </Box>
                                    </ListItemButton>
                                </ListItem>
                            );
                        })
                    ) : (
                        <Typography variant="subtitle1" padding={2}>
                            Data not found
                        </Typography>
                    )}
                </List>
            )}
        </>
    );
};

export default ListContainer;
